import axios from "axios";
import { getAuth } from "../providers/AppAuthProvider";

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = "users"

export async function getDetailUser(userId: string) {
  const url = `${baseUrl}/${resource}/${userId}`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.get<any>(
    url,
    {
      headers,
    }
  );
}

export async function assignRoles(id: string, roleIds: string[]) {
  const url = `${baseUrl}/users/${id}/role`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.post<any>(
    url,
    {
      "roleIds": roleIds
    },
    {
      headers,
    }
  );
}

export async function assignPermissions(id: string, permissionIds: string[]) {
  const url = `${baseUrl}/users/${id}/permission`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.post<any>(
    url,
    {
      "permissionIds": permissionIds
    },
    {
      headers,
    }
  );
}

export async function resetPassword(id: string, body: { newPassword: string; currentPassword: string }) {
  const url = `${baseUrl}/users/${id}/reset-password`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.post<any>(url, body, { headers });
}

export async function resetTwoFactor(id: string, otp: string) {
  const url = `${baseUrl}/users/${id}/reset-2fa`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: "application/json",
  };

  return axios.post<any>(url, { otp }, { headers });
}
